__turbopack_context__.v({
  "group": "style-module-scss-module__u7PeQq__group",
  "item": "style-module-scss-module__u7PeQq__item",
  "marquee": "style-module-scss-module__u7PeQq__marquee",
  "pauseOnHover": "style-module-scss-module__u7PeQq__pauseOnHover",
  "section": "style-module-scss-module__u7PeQq__section",
  "viewport": "style-module-scss-module__u7PeQq__viewport",
});
